import { useState } from "react";
import Button from "../components/button/Button";
import { ParseErrors } from "../utils/parse-errors";
import { toast } from "react-toastify";
import axiosInstance from "../utils/axios-instance";
import ExporttoText from "../utils/export-file";

interface IExportConversationModel {
  id: number;
  toggleModel: () => void;
}

const ExportConversationModel = ({
  id,
  toggleModel,
}: IExportConversationModel) => {
  const [loading, setLoading] = useState(false);

  const downloadUserData = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.post(
        `/chat/export/user/conversation/${id}`
      );
      ExporttoText(res.data.data)
      toast.success("Conversation Exported Successfully!");
      toggleModel();
      setLoading(false);
    } catch (error) {
      console.log(error);
      toast.error(ParseErrors(error));
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-full fixed top-0 bg-black/50 backdrop-blur-sm left-0 z-50 flex items-center justify-center px-4">
      <div className="p-7 rounded-2xl bg-white shadow-pop w-full max-w-[460px] fade-up">
        <div className="flex items-start gap-4">
          <div className="h-11 w-11 rounded-full bg-blue/10 flex items-center justify-center shrink-0">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#5299D3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
          </div>
          <div>
            <h2 className="font-display text-lg font-semibold tracking-tight text-lightBlack">
              {loading ? "Exporting data…" : "Export conversations?"}
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              We'll generate a downloadable text file with all conversations.
            </p>
          </div>
        </div>

        <div className="mt-7 flex items-center justify-end gap-3">
          <div className="w-auto">
            <Button variant="secondary" className="!w-auto !px-5" onClick={toggleModel} disabled={loading}>
              Cancel
            </Button>
          </div>
          <div className="w-auto">
            <Button className="!w-auto !px-5" onClick={downloadUserData} disabled={loading} isLoading={loading}>
              Export
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportConversationModel;
